(function () {
  if (window.mainChangableDirectCheckoutInitialized) return;
  window.mainChangableDirectCheckoutInitialized = true;

  var pendingForms = new Set();

  function setLoading(form, loading) {
    var button = form.querySelector('[data-add-to-cart]');
    if (!button) return;
    button.setAttribute('aria-disabled', String(loading));
    button.setAttribute('aria-busy', String(loading));
    var text = button.querySelector('[data-add-to-cart-text]');
    var loader = button.querySelector('[data-loader]');
    if (text) text.classList.toggle('hide', loading);
    if (loader) loader.classList.toggle('hide', !loading);
  }

  window.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form.matches('form[data-product-form][data-direct-checkout="true"]')) return;
    if (event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var button = form.querySelector('[data-add-to-cart]');
    if (pendingForms.has(form) || !button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (!form.reportValidity()) return;

    var errorWrapper = form.querySelector('[data-error-message-wrapper]');
    var errorText = form.querySelector('[data-error-message]');
    var hiddenErrorClass = 'product-form__error-message-wrapper--hidden';
    if (errorWrapper) errorWrapper.classList.add(hiddenErrorClass);
    pendingForms.add(form);
    setLoading(form, true);

    try {
      var body = new FormData(form);
      body.delete('return_to');
      var addUrl = new URL(form.action, window.location.origin);
      addUrl.pathname = addUrl.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
      var response = await fetch(addUrl.href, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: body
      });
      var result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || window.theme.strings.cartError);
      }
      window.location.assign('/checkout');
    } catch (error) {
      if (errorText) errorText.textContent = error.message || window.theme.strings.cartError;
      if (errorWrapper) errorWrapper.classList.remove(hiddenErrorClass);
      pendingForms.delete(form);
      setLoading(form, false);
    }
  }, true);

  window.addEventListener('pageshow', function () {
    pendingForms.forEach(function (form) {
      setLoading(form, false);
    });
    pendingForms.clear();
  });
})();
